module.exports = __webpack_public_path__ + "img/HSBC.113e6d40.png";